/**
 * Route prefix for the admin surfaces.
 *
 * A Zonal Manager uses the same Admin pages, scoped server-side to the schools
 * they own — so the pages, components and API slices are shared and only the
 * prefix differs. Deriving it from the stored role keeps one implementation
 * instead of a parallel panel that drifts every time Admin changes.
 */
export const adminBase = () =>
	localStorage.getItem('alforaa_role') === 'zonal_manager'
		? '/zonal'
		: '/master-admin';
